// frontend/src/components/ManageFilesModal.js

import React, { useState, useEffect, useRef } from "react";
import { toast } from 'react-toastify';
import * as api from "../api";

function ManageFilesModal({ isOpen, onClose, onFilesChanged, collectionId }) {
  const [pdfs, setPdfs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [newFiles, setNewFiles] = useState(null);
  const fileInputRef = useRef(null);

  const fetchPdfs = async () => {
    if (collectionId) {
      setIsLoading(true);
      try {
        const response = await api.getCollectionPdfs(collectionId);
        const sortedPdfs = response.data.pdf_order.length > 0
          ? response.data.pdfs.sort((a, b) => 
              response.data.pdf_order.indexOf(a.filename) - response.data.pdf_order.indexOf(b.filename)
            )
          : response.data.pdfs;
        setPdfs(sortedPdfs);
      } catch (error) {
        console.error("Erro ao buscar PDFs", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchPdfs();
    }
  }, [isOpen, collectionId]);

  const handleDelete = async (filename) => {
    if (window.confirm(`Tem certeza que deseja deletar o arquivo ${filename}?`)) {
      try {
        await api.deletePdf(collectionId, filename);
        toast.success(`Arquivo "${filename}" deletado.`);
        fetchPdfs(); // Atualiza a lista
        onFilesChanged(); // Notifica o dashboard
        
      } catch (err) {
        toast.error("Não foi possível deletar o arquivo.");
        console.error("Erro ao deletar PDF:", err);
      }
    }
  };

  const handleAddFiles = async () => {
    if (!newFiles || newFiles.length === 0) {
      toast.warn("Por favor, selecione arquivos para adicionar.");
      return;
    }
    const formData = new FormData();
    for (let i = 0; i < newFiles.length; i++) {
      formData.append("files[]", newFiles[i]);
    }

    try {
      await api.addPdfs(collectionId, formData);
      toast.success("Arquivos adicionados com sucesso!");
      setNewFiles(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      fetchPdfs(); // Atualiza a lista
      onFilesChanged(); // Notifica o dashboard
    } catch (err) {
      toast.error("Não foi possível adicionar os arquivos.");
      console.error("Erro ao adicionar PDFs:", err);
    }
  };
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <h3 className="text-2xl font-bold mb-6 text-gray-900 flex-shrink-0">Gerenciar Arquivos</h3>

        {isLoading ? <p>A carregar...</p> : (
          <div className="overflow-y-auto pr-4 flex-grow min-h-0">
            {/* Seção de Adicionar Novos Arquivos */}
            <div className="mb-8 p-4 border rounded-lg">
              <h4 className="text-lg font-semibold mb-3">Adicionar Novos PDFs</h4>
              <input 
                type="file" 
                multiple 
                accept="application/pdf"
                ref={fileInputRef}
                onChange={(e) => setNewFiles(e.target.files)}
                className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 mb-3"
              />
              <button onClick={handleAddFiles} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg w-full">Fazer Upload</button>
            </div>
            
            {/* Lista de Arquivos Atuais */}
            <div>
                <h4 className="text-lg font-semibold mb-3">Arquivos Atuais</h4>
                <ul className="space-y-2">
                {pdfs.map((pdf) => (
                    <li key={pdf.filename} className="p-3 bg-gray-100 rounded-md border text-gray-800 flex items-center justify-between">
                    <span>{pdf.filename}</span>
                    <button 
                        onClick={() => handleDelete(pdf.filename)}
                        className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold py-1 px-2 rounded-md"
                    >
                        Excluir
                    </button>
                    </li>
                ))}
                </ul>
                {pdfs.length === 0 && <p className="text-gray-500 text-center py-4">Nenhum PDF nesta coleção.</p>}
            </div>
          </div>
        )}

        <div className="mt-8 flex justify-end space-x-4 flex-shrink-0">
          <button type="button" onClick={onClose} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded-lg">Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default ManageFilesModal;